"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { ImageOff } from "lucide-react";
import { PhotoPreviewGroup } from "@/components/molecules/PhotoPreviewGroup/PhotoPreviewGroup";
import { useAssociatePhotosStep } from "./useAssociatePhotosStep";
export function AssociatePhotosStep(t0) {
  const $ = _c(14);
  const {
    propertyPhotos,
    listingId
  } = t0;
  const t = useTranslations("modules.portfolio.associateListingToUnit.stepper");
  const {
    existingPictures
  } = useAssociatePhotosStep(listingId);
  let t1;
  if ($[0] !== t) {
    t1 = t("currentPhotosLabel");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("currentPhotosDescription");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== existingPictures || $[5] !== t1 || $[6] !== t2) {
    t3 = <PhotoPreviewGroup label={t1} description={t2} photos={existingPictures} data-sentry-element="PhotoPreviewGroup" data-sentry-source-file="AssociatePhotosStep.tsx" />;
    $[4] = existingPictures;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== propertyPhotos || $[9] !== t) {
    t4 = propertyPhotos.length > 0 ? <PhotoPreviewGroup label={t("imagesLabel")} description={t("imagesDescription")} photos={propertyPhotos} columns={3} columnsMd={5} /> : <div className="flex flex-1 flex-col items-center justify-center gap-2 py-10 text-center text-zinc-400"><ImageOff className="h-8 w-8" /><p className="text-sm">{t("noPropertyPhotos")}</p></div>;
    $[8] = propertyPhotos;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex flex-col gap-6" data-sentry-component="AssociatePhotosStep" data-sentry-source-file="AssociatePhotosStep.tsx">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}